import { navigation } from "./navigation";

export const Link = navigation.Link;
